'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import warning from 'fbjs/lib/warning';
// import messages from '../core/messages';
// warning(!attrs.length, messages.mergeWarning, 'update', attrs.join(','), modelName, 'Beatle.ReduxSeed');
var StateObserver = function () {
  function StateObserver(storeState, modelState, callback) {
    var _this = this;

    (0, _classCallCheck3.default)(this, StateObserver);

    this._store = storeState;

    var _loop = function _loop(key) {
      if (modelState.hasOwnProperty(key)) {
        _this[key] = modelState[key];
        Object.defineProperty(_this, key, {
          get: function get() {
            // if (Object(modelState[key]) === modelState[key]) {
            //   return new StateObserver(storeState[key], modelState[key]);
            // } else {
            //   return modelState[key];
            // }
            return modelState[key];
          },
          set: function set(v) {
            if (storeState.asMutable) {
              this._store = storeState = storeState.set(key, v);
            } else {
              this._store[key] = storeState[key] = v;
            }
            callback && callback(key, v);
            modelState[key] = v;
          },

          enumerable: false
        });
      }
    };

    for (var key in modelState) {
      _loop(key);
    }

    this.forceUpdate = callback;
  }

  (0, _createClass3.default)(StateObserver, [{
    key: 'getStore',
    value: function getStore() {
      for (var key in this) {
        if (key !== '_store') {
          if (this._store.asMutable) {
            this._store = this._store.set(key, this[key]);
          } else {
            this._store[key] = this[key];
          }
        }
      }
      return this._store;
    }
  }]);
  return StateObserver;
}();

exports.default = StateObserver;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/seed/stateObserver.js
// module id = 88
// module chunks = 0